export default __webpack_public_path__ + "static/media/logo.dc60eff0.png";